// Alignment snapping, after tessera's canvas/snapping.ts. While dragging, the
// moving bounds' edges and centres are compared with every static rect; the
// closest candidate within a few *screen* pixels on each axis wins.

import { type Rect, type Vec } from './geometry'

export const SNAP_PX = 6

export type SnapGuides = { vertical: number[]; horizontal: number[] }
export type SnapResult = { delta: Vec; guides: SnapGuides }

const xs = (r: Rect) => [r.x, r.x + r.w / 2, r.x + r.w]
const ys = (r: Rect) => [r.y, r.y + r.h / 2, r.y + r.h]

export function computeSnap(
  dragged: Rect,
  delta: Vec,
  statics: readonly Rect[],
  zoom: number,
): SnapResult {
  const threshold = SNAP_PX / zoom
  const moved = { ...dragged, x: dragged.x + delta.x, y: dragged.y + delta.y }
  let bx: { adjust: number; at: number } | null = null
  let by: { adjust: number; at: number } | null = null
  for (const t of statics) {
    for (const tx of xs(t))
      for (const mx of xs(moved)) {
        const d = tx - mx
        if (Math.abs(d) <= threshold && (!bx || Math.abs(d) < Math.abs(bx.adjust)))
          bx = { adjust: d, at: tx }
      }
    for (const ty of ys(t))
      for (const my of ys(moved)) {
        const d = ty - my
        if (Math.abs(d) <= threshold && (!by || Math.abs(d) < Math.abs(by.adjust)))
          by = { adjust: d, at: ty }
      }
  }
  return {
    delta: { x: delta.x + (bx?.adjust ?? 0), y: delta.y + (by?.adjust ?? 0) },
    guides: { vertical: bx ? [bx.at] : [], horizontal: by ? [by.at] : [] },
  }
}
